import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography, Card, CardContent, InputAdornment, Alert, CircularProgress } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { authServices } from '../../services/authentication/authServices';
import '../../css/Password.css';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [warningMessage, setWarningMessage] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.state?.errorMessage) {
            setWarningMessage(location.state.errorMessage);
            window.history.replaceState({}, document.title);
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const message = await authServices.requestOtp(email);
            sessionStorage.setItem(`otp_timer_${email}`, Date.now() + 120000);
            navigate('/verify-otp', { state: { email, initialMessage: message }, replace: true });
        } catch (err) {
            setError('Something went wrong. Please try again.');
            setTimeout(() => setError(null), 4000);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page-wrapper">
            <Card sx={{ width: 400, padding: '1.25rem', borderRadius: '1rem', boxShadow: 3, backgroundColor: '#ffffff' }}>
                <CardContent>
                    <Typography variant="h3" align="center" gutterBottom sx={{
                        fontWeight: 700, fontSize: '2rem', color: '#045864', letterSpacing: '2px'
                    }}>
                        Workmate
                    </Typography>

                    <Typography variant="body1" align="center" sx={{ color: '#64748b', mb: 2, fontSize: '0.95rem' }}>
                        Enter your registered email address. We'll send you an OTP to reset your password.
                    </Typography>

                    {warningMessage && (
                        <Alert variant="filled" severity="warning" sx={{ marginTop: 2, mb: 1 }}>
                            {warningMessage}
                        </Alert>
                    )}
                    {error && (
                        <Alert variant="outlined" severity="error" sx={{ marginTop: 2 }}>
                            {error}
                        </Alert>
                    )}

                    <form onSubmit={handleSubmit}>
                        <TextField
                            label="Registered Email"
                            variant="outlined"
                            fullWidth
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            margin="normal"
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <i className="fa fa-envelope auth-input-icon"></i>
                                        </InputAdornment>
                                    ),
                                }
                            }}
                        />

                        <Button
                            type="submit"
                            variant="contained"
                            fullWidth
                            disabled={loading}
                            sx={{
                                marginTop: 2,
                                padding: '0.75rem',
                                fontSize: '1rem',
                                textTransform: 'none',
                                backgroundColor: '#045864',
                                '&:hover': { backgroundColor: '#034a54' }
                            }}
                        >
                            {loading ? <CircularProgress size={22} color="inherit" /> : 'Send OTP'}
                        </Button>

                        <div className="auth-back-link">
                            <Button
                                variant="text"
                                onClick={() => navigate('/login')}
                                sx={{ color: '#045864', textTransform: 'none', fontSize: '0.875rem' }}
                            >
                                ← Back to Login
                            </Button>
                        </div>
                    </form>
                </CardContent>
            </Card>
        </div>
    );
};

export default ForgotPassword;
